const ROOT = import.meta.env.VITE_API_URL || "http://localhost:8000";
const BASE = ROOT + "/api";
const TOKEN_KEY = "remifo_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* storage unavailable */
  }
};

function authHeaders(extra) {
  const t = getToken();
  return {
    ...(extra || {}),
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
  };
}

async function handle(res) {
  if (!res.ok) {
    let detail = "";
    try {
      detail = (await res.json()).detail || "";
    } catch {
      /* ignore */
    }
    const err = new Error(`${res.status} ${detail}`.trim());
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: authHeaders(body !== undefined ? { "Content-Type": "application/json" } : undefined),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return handle(res);
}

export const get = (path) => req("GET", path);
export const post = (path, body) => req("POST", path, body ?? {});
export const put = (path, body) => req("PUT", path, body ?? {});
export const del = (path) => req("DELETE", path);

// Multipart file upload (used to extract text from PDF, Word, Excel, CSV).
export async function upload(path, file) {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(BASE + path, {
    method: "POST",
    headers: authHeaders(),
    body: form,
  });
  return handle(res);
}

// Authenticated binary download (used to export the calendar to PDF or Word).
export async function download(path) {
  const res = await fetch(BASE + path, { headers: authHeaders() });
  if (!res.ok) {
    const err = new Error(`${res.status}`);
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const match = cd.match(/filename="?([^"]+)"?/);
  return { blob, filename: match ? match[1] : "" };
}